module.exports = __webpack_public_path__ + "static/media/03-banner-06-perisur-mobile@2x.c9c5f4fd.jpg";